.hidden {
  position: absolute;
  right: 8px;
  color: var(--tuna-content-muted);
  font-style: italic;
  font-size: var(--tuna-typography-fontSize-xs);
}

.hiddenChildren {
  display: none;
}
